import React, { useState } from "react";
import { Menu, X, Facebook } from "lucide-react";
import { Button } from "./ui/button";

const LOGO_URL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_bold-davinci-9/artifacts/2e1q3mah_Screenshot%202026-07-24%20at%201.01.30%E2%80%AFPM.png";

const FACEBOOK_URL =
  "https://www.facebook.com/people/Friends-of-Greg-Clark/61591538444437/";

const NAV = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "News", href: "#news" },
  { label: "Donate", href: "#donate" },
  { label: "Contact", href: "#contact" },
];

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="relative z-40">
      {/* Top red-white-blue stripe */}
      <div className="divider-stripe" />

      {/* Row 1: sticky nav links + action buttons */}
      <div className="sticky top-0 z-50 bg-white/95 backdrop-blur header-shadow">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="flex items-center justify-between h-20">
            <nav className="hidden lg:flex items-center gap-9">
              {NAV.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className="nav-link font-oswald text-[15px] font-semibold uppercase tracking-[0.14em] text-[#0b1e3f] hover:text-[#b22234]"
                >
                  {item.label}
                </a>
              ))}
            </nav>

            <div className="hidden lg:flex items-center gap-3 ml-auto">
              <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer">
                <Button className="bg-[#1877F2] hover:bg-[#0f5cbf] text-white rounded-full px-5 h-11 font-oswald font-semibold uppercase tracking-[0.14em] text-sm shadow-sm">
                  <Facebook className="w-4 h-4 mr-2" />
                  Facebook
                </Button>
              </a>
              <a href="#donate">
                <Button className="bg-[#b22234] hover:bg-[#8f1a29] text-white rounded-full px-6 h-11 font-oswald font-semibold uppercase tracking-[0.14em] text-sm shadow-sm">
                  Donate
                </Button>
              </a>
            </div>

            <button
              className="lg:hidden p-2 text-[#0a3161] ml-auto"
              onClick={() => setOpen((s) => !s)}
              aria-label="Toggle menu"
            >
              {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>

          {open && (
            <div className="lg:hidden pb-6 pt-2 border-t border-slate-100">
              <div className="flex flex-col gap-4 pt-4">
                {NAV.map((item) => (
                  <a
                    key={item.label}
                    href={item.href}
                    onClick={() => setOpen(false)}
                    className="font-oswald text-base font-semibold uppercase tracking-[0.14em] text-[#0b1e3f] hover:text-[#b22234]"
                  >
                    {item.label}
                  </a>
                ))}
                <a href="#donate" onClick={() => setOpen(false)}>
                  <Button className="w-full bg-[#b22234] hover:bg-[#8f1a29] text-white rounded-full h-11 font-oswald font-semibold uppercase tracking-[0.14em]">
                    Donate
                  </Button>
                </a>
                <a
                  href={FACEBOOK_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setOpen(false)}
                >
                  <Button className="w-full bg-[#1877F2] hover:bg-[#0f5cbf] text-white rounded-full h-11 font-oswald font-semibold uppercase tracking-[0.14em]">
                    <Facebook className="w-4 h-4 mr-2" />
                    Follow on Facebook
                  </Button>
                </a>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Row 2: large centered logo (scrolls away naturally) */}
      <div className="w-full bg-white flex justify-center py-6 md:py-8">
        <a href="#home" className="group inline-block">
          <img
            src={LOGO_URL}
            alt="Greg Clark for 19th District, Oswego County Legislature"
            className="w-[90vw] max-w-[90vw] md:w-[560px] md:max-w-[560px] lg:w-[680px] lg:max-w-[680px] h-auto group-hover:scale-[1.01] transition-transform"
          />
        </a>
      </div>
    </header>
  );
};

export default Header;
